import { render, staticRenderFns } from "./df-page-recipes.vue?vue&type=template&id=59e6b7ef"
import script from "./df-page-recipes.ts?vue&type=script&lang=js&external"
export * from "./df-page-recipes.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports